import React from 'react';
import { styles } from './Dashboard.styles';
import RMSvgIcon, {
  RMSvgIconNames,
} from 'components/customComponents/CommonComponents/RMSvgIcon';

type IUpdatesAndNews = {
  title1: string;
  title2: string;
  svgName: RMSvgIconNames;
  onClick?: () => void;
};

export default function UpdatesAndNews({
  title1,
  title2,
  svgName,
  onClick,
}: IUpdatesAndNews) {
  return (
    <div id='updatesandnews-updates-news-web-help-wrapper' className="dashboard-Help-News">
      <div id='updatesandnews-container' style={styles.dashboardNewsAndHelp}>
        <div>
          <h2 id='updatesandnews-welcome-text-title-1' style={styles.welcomeTextTitle}>{title1}</h2>
          <h2 id='updatesandnews-welcome-text-title-2' style={styles.welcomeTextTitle}>{title2}</h2>
          <p id='updatesandnews-welcome-text-container' style={styles.welcomeTextContainer}></p>
        </div>
        <RMSvgIcon
          id='updatesandnews-rm-svg-icon' name={svgName}
          height={'100px'}
          width={'115px'}
          style={styles.svgStyle}
          preserveAspectRatio="none"
        />
        <RMSvgIcon
          id='updatesandnews-rm-svg-icon-open-link' name="OpenLink"
          height={'15px'}
          width={'15px'}
          style={styles.linkSvg}
          preserveAspectRatio="none"
          onClick={onClick}
        />
      </div>
    </div>
  );
}
